import React from "react";

export function DuplicateIcon(props: any) {
    return (
      <svg
        viewBox="0 0 16 16"
        fill="currentColor"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.375 14.4688H8.9375C9.17188 14.4688 9.40625 14.2637 9.40625 14V12.125H10.8125V14C10.8125 15.0547 9.96289 15.875 8.9375 15.875H2.375C1.32031 15.875 0.5 15.0547 0.5 14V7.4375C0.5 6.41211 1.32031 5.5625 2.375 5.5625H4.25V6.96875H2.375C2.11133 6.96875 1.90625 7.20312 1.90625 7.4375V14C1.90625 14.2637 2.11133 14.4688 2.375 14.4688ZM5.1875 2.75C5.1875 1.72461 6.00781 0.875 7.0625 0.875H13.625C14.6504 0.875 15.5 1.72461 15.5 2.75V9.3125C15.5 10.3672 14.6504 11.1875 13.625 11.1875H7.0625C6.00781 11.1875 5.1875 10.3672 5.1875 9.3125V2.75ZM7.0625 9.78125H13.625C13.8594 9.78125 14.0938 9.57617 14.0938 9.3125V2.75C14.0938 2.51562 13.8594 2.28125 13.625 2.28125H7.0625C6.79883 2.28125 6.59375 2.51562 6.59375 2.75V9.3125C6.59375 9.57617 6.79883 9.78125 7.0625 9.78125Z"
          fill="#333333"
        />
      </svg>
    );
  }
  